import React from 'react'

const Accounts = () => {
  return (
    <div className='mx-auto p-4'>
      Accounts
    </div>
  )
}

export default Accounts
